import { render, staticRenderFns } from "./IncomesByRouteId.vue?vue&type=template&id=fabcda28&scoped=true&"
import script from "./IncomesByRouteId.vue?vue&type=script&lang=js&"
export * from "./IncomesByRouteId.vue?vue&type=script&lang=js&"
import style0 from "./IncomesByRouteId.vue?vue&type=style&index=0&id=fabcda28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabcda28",
  null
  
)

export default component.exports